// extracted by mini-css-extract-plugin
module.exports = {"bottom-column-wapper":"gg","bottomColumnWapper":"gg","bottom-column-panel":"gh","bottomColumnPanel":"gh"};